import React from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";
import { currency } from "../helper";

const ProductDetailsCard = ({
  _id,
  image,
  name,
  price,
  description,
  link = "",
}) => {
  return (
    <Wrapper className="product-details-card">
      <div className="image">
        <img src={image} alt="asjad" />
      </div>
      <div className="info">
        <h2>{name.toLowerCase()}</h2>
        <h4>
          {currency} {price}
        </h4>
        <p>{description.substring(0, 60)}...</p>
        <Link to={`/products/${_id}`}>
          <button className="btn">Details</button>
        </Link>
      </div>
    </Wrapper>
  );
};

export default ProductDetailsCard;

const Wrapper = styled.div`
  max-width: 1000px;
  display: flex;
  align-items: center;
  .image {
    position: relative;
    background-color: #000;
    border-radius: 6px;
    overflow: hidden;
    height: 200px;
    width: 300px;
    > img {
      transition: var(--transition-1);
      width: 100%;
      height: 100%;
      display: block;
      position: relative;
      object-fit: cover;
    }
  }
  .info {
    margin-left: 2em;
    > h2 {
      color: var(--color-black-1);
      font-weight: bolder;
      text-transform: capitalize;
    }
    > h4 {
      color: var(--color-primary-1);
      margin-top: 10px;
    }
    > p {
      color: var(--color-black-1);
      margin-top: 10px;
    }
    a {
      > button {
        margin-top: 10px;
        padding: 0.5em 0.8em;
      }
    }
  }
  @media screen and (max-width: 800px) {
    .image {
      width: 200px;
    }
  }
  @media screen and (max-width: 800px) {
    flex-direction: column;
    .image {
      width: 100%;
    }
    .info {
      margin: 5px 0;
    }
  }
`;
